import { render, staticRenderFns } from "./EmptyListStub.vue?vue&type=template&id=56db425a&lang=true&"
import script from "./EmptyListStub.vue?vue&type=script&lang=js&"
export * from "./EmptyListStub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports